// Common princing functions
import { setCookie } from "../main";
import { triggerChange } from "./eventTarget";
import { getUserCountryByIp } from "./userIp";
const OTActive = (typeof OnetrustActiveGroups != 'undefined' && OnetrustActiveGroups.includes("C0001")) ? true : false;
const currencySelector = document.querySelector('.currency');
let time = 500;
if (location.host === 'local-new.fromdoppler.com' || location.host === 'localhost') {
  time = 1500
}


const addCommas = (nStr) => {
  const lang = document.documentElement.lang;
  const charSeparate = lang === 'en' ? ',' : '.';
  const lastCharSeparate = lang === 'en' ? '.' : ',';

  // Aseguramos que nStr es un string
  nStr = nStr.toString();

  // Dividimos el número en parte entera y decimal
  const [integerPart, decimalPart] = nStr.split('.');

  // Eliminamos separadores previos de la parte entera
  const cleanIntegerPart = integerPart.replace(/[,.]/g, '');

  // Formateamos la parte entera con separadores
  const formattedInteger = cleanIntegerPart.replace(/\B(?=(\d{3})+(?!\d))/g, charSeparate);

  // Reconstruimos el número con la parte decimal, si existe
  return decimalPart !== undefined
    ? `${formattedInteger}${lastCharSeparate}${decimalPart}`
    : formattedInteger;
};


function setCookieWithSelector(selector) {
  let selectedIndex = selector.options.selectedIndex;
  if (selector.options[selectedIndex] === undefined) return;
  let currencyName = selector.value,
    currencySymbol = selector.options[selectedIndex].getAttribute("data-currency"),
    currencyRate = selector.options[selectedIndex].getAttribute("data-rate");

  if (OTActive) { // Functional Cookies
    setCookie('currencySelector', currencyName);
  }

  if (currencyName !== undefined && currencyName !== null) {
    var currentCurrency = {
      value: currencyName,
      symbol: currencySymbol,
      rate: currencyRate,
    };

    setCookie('currentCurrency', JSON.stringify(currentCurrency));
  }
}


const checkCountryIncludedInEurope = () => {
  const euTimeZones = [
    'Europe/Vienna',
    'Europe/Brussels',
    'Europe/Sofia',
    'Europe/Zagreb',
    'Asia/Famagusta',
    'Asia/Nicosia',
    'Europe/Prague',
    'Europe/Copenhagen',
    'Europe/Tallinn',
    'Europe/Helsinki',
    'Europe/Paris',
    'Europe/Berlin',
    'Europe/Busingen',
    'Europe/Athens',
    'Europe/Budapest',
    'Europe/Dublin',
    'Europe/Rome',
    'Europe/Riga',
    'Europe/Vilnius',
    'Europe/Luxembourg',
    'Europe/Malta',
    'Europe/Amsterdam',
    'Europe/Warsaw',
    'Atlantic/Azores',
    'Atlantic/Madeira',
    'Europe/Lisbon',
    'Europe/Bucharest',
    'Europe/Bratislava',
    'Europe/Ljubljana',
    'Africa/Ceuta',
    'Atlantic/Canary',
    'Europe/Madrid',
    'Europe/Stockholm'
  ];
  const userTimeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return euTimeZones.includes(userTimeZoneName)
}
const getCountryCurrencyName = (countryAbbreviatedName) => {
  let name = '';
  switch (countryAbbreviatedName) {
    case 'AR':
      name = 'ARS';
      break;
    case 'BO':
      name = 'BOB';
      break;
    case 'BR':
      name = 'BRL';
      break;
    case 'CL':
      name = 'CLP';
      break;
    case 'CO':
      name = 'COP';
      break;
    case 'DO':
      name = 'DOP';
      break;
    case 'MX':
      name = 'MXN';
      break;
    case 'PY':
      name = 'PYG';
      break;
    case 'PE':
      name = 'PEN';
      break;
    case 'UY':
      name = 'UYU';
      break;
    case 'VE':
      name = 'VES';
      break;
    default:
      name = 'USD';
  }
  return name;
}

const setUserCurrencyByCountry = ({ countryName, countryCode }) => {
  let userCountry = countryCode;
  let currencyName = 'USD';
  const searchedCountries = ['AR', 'BO', 'BR', 'CL', 'CO', 'DO', 'MX', 'PY', 'PE', 'UY', 'VE'];

  if (!searchedCountries.includes(countryCode)) {
    const isEuCountry = checkCountryIncludedInEurope();
    if (isEuCountry) {
      currencyName = 'EUR'
    } else {
      currencyName = 'USD'
    }
  } else {
    currencyName = getCountryCurrencyName(userCountry)
  };

  setCookie('currencySelector', currencyName);
  if (currencySelector != undefined || currencySelector != null) {
    currencySelector.value = currencyName;
    setTimeout(() => { triggerChange(currencySelector); }, time);
  }
}

const setUserCurrencyByIp = () => {
  getUserCountryByIp()
    .then(resp => resp.text())
    .then(country => {
      country = JSON.parse(country)
      setUserCurrencyByCountry(country)
    });
}

const getCurrenciesValues = async () => {
  const lang = document.documentElement.lang;
  const url = '/backend/pricing/currenciesProxy.php?getLatestCurrencies=true&productFilter=DOPPLER&language=' + lang;
  const resp = await fetch(url);
  const data = await resp.json();
  return data;
}

const getArgentinaDiscountValue = () => {
  return document.getElementById('specialDiscountArg').value;
}


const createUserCountryCache = () => {
	let cachedUserCountry = null;
	return async () => {
		// Si ya hemos obtenido el país, devolvemos el valor almacenado
		if (cachedUserCountry !== null) {
			return cachedUserCountry;
		}

		// Si no, realizamos la solicitud y almacenamos el resultado
		try {
			const response = await getUserCountryByIp();
			const { countryCode } = JSON.parse(await response.text());
			cachedUserCountry = countryCode;
			return countryCode;
		} catch (error) {
			console.error('Error obteniendo el país por IP:', error);
			return null;
		}
	};
};

export {
  addCommas,
  setCookieWithSelector,
  getCountryCurrencyName,
  setUserCurrencyByCountry,
  setUserCurrencyByIp,
  getCurrenciesValues,
  getArgentinaDiscountValue,
  createUserCountryCache
};
